<template>
        <div class="customers">

            <div class="customers__inner">
                <!--BEGIN HEADER-->
                <div class="customers__header">
                    <div class="location">
                        <div class="location__title"> {{getCustomersLocation.name}}</div>
                        <div class="location__address"> {{getCustomersLocation.address}}</div>
                    </div>
                    <div class="customers__close" @click="closePopup">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.6894 0.321199C13.2753 -0.0929084 12.6064 -0.0929084 12.1923 0.321199L7 5.50284L1.80774 0.31058C1.39363 -0.103527 0.724687 -0.103527 0.31058 0.31058C-0.103527 0.724687 -0.103527 1.39363 0.31058 1.80774L5.50284 7L0.31058 12.1923C-0.103527 12.6064 -0.103527 13.2753 0.31058 13.6894C0.724687 14.1035 1.39363 14.1035 1.80774 13.6894L7 8.49716L12.1923 13.6894C12.6064 14.1035 13.2753 14.1035 13.6894 13.6894C14.1035 13.2753 14.1035 12.6064 13.6894 12.1923L8.49716 7L13.6894 1.80774C14.0929 1.40425 14.0929 0.724687 13.6894 0.321199Z"></path></svg>
                    </div>
                </div>
                <!--END HEADER-->
                <!--BEGIN BODY-->
                <div class="customers__body">
                    <!--BEGIN TABLE-->
                    <div class="table">
                        <div class="table__header">
                            <div class="table__desc">
                                {{ $t('row') }}
                            </div>
                            <div class="table__actions">
                                <tableFilters @updateFilter="updateFilter" v-for="(key,idx) in fieldKeys" :field="fieldKeys[idx]" :options="options" :key="idx" :selected="filters[key]"></tableFilters>
                            </div>

                        </div>
                        <!--BEGIN BODY-->
                        <tableColumns :customers="customers"></tableColumns>
                        <!--END BODY-->
                    </div>
                    <!--END TABLE-->
                </div>
                <!--END BODY-->
                <!--BEGIN FOOTER-->
                <div class="customers__footer">
                    <button class="btn btn-blue btn-main" @click="startGeoCoding">{{ $t('buttonStartGeocoding') }}</button>
                    <button class="btn btn-blue btn-secondary" @click="closePopup">{{ $t('buttonClose') }}</button>
                </div>
                <!--END FOOTER-->
            </div>

        </div>

</template>
<script>
import {mapGetters} from 'vuex'
import tableColumns from './customersTable.vue'
import tableFilters from './customersTableFilter.vue'
export default {
    components: {
        tableColumns,
        tableFilters
    },
    data() {
        return {
            filters: {},
            options: [
                {
                    title: 'importColumnName',
                    value: 'name'
                },
                {
                    title: 'importColumnFirstName',
                    value: 'first_name'
                },
                {
                    title: 'importColumnSurname',
                    value: 'last_name'
                },
                {
                    title: 'importColumnAddress',
                    value: "address"
                },
                {
                    title: 'importColumnPostalCode',
                    value: "postal_code"
                },
                {
                    title: 'importColumnPhoneNumber',
                    value: "phone_number"
                },
                {
                    title: 'importColumnSelectColumn',
                    value: ""
                }
            ],
            items:
                [["1", "Abel", "Rudiger", "Birkenstr. 7", "85354", "", ""], ["2", "Aigner", "Andreas", "Eixendorf 5", "85417", "", ""], ["3", "Ander", "David", "AttachingerWeg 45", "85356", "", ""], ["4", "Anneser", "Katharina", "Garten 4", "85354", "", ""], ["5", "Beige", "Sabine", "Buckenring 3", "85395", "", ""], ["6", "Zimmermann", "Henning", "Katherine-Geisler-Str.5", "85356", "", ""]]}
    },
    methods: {
        updateFilter(data) {
            let {name, value} = data;
            this.filters[name] = value
        },
      closePopup() {
          this.$store.dispatch('SHOW_CUSTOMERS_POPUP', false)
      },
        createColumns() {
            let array = ['id'];
            Object.keys(this.filters)
                .forEach(item => array.push(this.filters[item]))
            return array
        },
        startGeoCoding() {
            let columns = this.createColumns();
            this.$store.dispatch('geocodeAddresses', columns)
        }
    },
    computed: {
        ...mapGetters(['getCustomers', 'getCustomersLocation', 'getCustomersPopup']),
        customers(){
            let newObj = {};
            let grid = [];

//            let options = this.options
            for (let i = 0; i < this.getCustomers.length; i++) {
                let innerArrayLength = this.getCustomers[i].length;
                for (let j = 0; j < innerArrayLength; j++) {
                    if (this.getCustomers[i][j]) {
                        newObj[j] = this.getCustomers[i][j]
//                        newObj[options[j]] = this.getCustomers[i][j]
//                        grid.push(this.getCustomers[i][j])
                    }
                }
                grid.push(newObj);
                newObj = {};
            }
            return grid;
        },
        fieldKeys() {
            let fields = {...this.customers[0]}
            delete fields [0]
            return Object.keys(fields)
        },
        setFieldKeys() {
            const filters = this.filters;
            this.fieldKeys.map(key => filters[key] = '')
            return filters;
        },
    },
    created() {
        this.setFieldKeys
    },
    beforeDestroy() {
        this.filters = {}
    }
}
</script>
<style lang="sass" scoped>
    .customers
        position: absolute
        top: 0
        left: 0
        width: 100%
        background: rgba(#000, 0.7)
        z-index: 11
        height: 100%
        &__header
            display: flex
            align-items: center
            justify-content: space-between
            margin: 0 -16px
            border-bottom: 1px solid $border--color-gray
            padding-bottom: 24px
            position: relative
            padding: 0 16px 24px
        &__inner
            background: $color--white
            box-shadow: 0px 2px 4px rgba(1, 37, 78, 0.2)
            border-radius: 4px
            margin: 32px 5px 0 5px
            padding: 24px 16px
            font-size: 14px
            +reg
            color: $color--dark
        &__footer
            display: flex
            justify-content: flex-end
            margin-top: 24px
            .btn + .btn
                margin-left: 16px
            .btn-main
                min-width: 240px
            .btn-secondary
                min-width: 120px
        &__close
            position: absolute
            right: 20px
            width: 14px
            height: 14px
            top: 7px
            cursor: pointer
            transform: translateY(-50%)
            path
                +tr(fill .3s ease)
                fill: rgba($color--dark, 0.3)
            &:hover
                path
                    fill: rgba($color--blue, 0.7)
        .location
            display: flex
            justify-content: flex-start
            align-items: center
            line-height: 18px
            &__title
                color: $color--dark
                font-size: 16px
                line-height: 16px
                +bold
            &__address
                margin-left: 8px
                color: $color--gray
                font-size: 14px
                line-height: 16px

    .table
        &__header
            padding: 16px 0
            display: flex
            justify-content: flex-start
            align-items: center
        &__desc
            +bold
            color: $color--dark
            flex: 0 0 80px
        &__actions
            display: flex
            width: 100%
        &__filters
            flex: 1
            margin-right: 30px
</style>